<mat-drawer-container class="example-container" autosize (backdropClick)="drawer.close()">
  <mat-drawer #drawer
              disableClose
              class="example-sidenav"
              [mode]="sidenavMode"
              [opened]="sidenavOpened">
    <div class="sidenav-header-container">
      <div class="logo-container" [class.logo-container-hidden]="drawer.opened">
        <img
          [alt]="title"
          src="../../../../assets/images/logo-header.png"/>
        <div class="title-container">
          <span class="title"><span class="main-name">Теніс-Мікс</span></span>
          <span class="subtitle">Грає вся сім'я</span>
        </div>
      </div>
      <button type="button" mat-button (click)="drawer.toggle()" mat-icon-button>
        <mat-icon>menu</mat-icon>
      </button>
    </div>

    <app-sidenav [drawer]="drawer"></app-sidenav>

  </mat-drawer>

  <div class="example-sidenav-content">
    <app-header [drawer]="drawer"></app-header>
    <div class="main-content">
      <router-outlet></router-outlet>
    </div>
    <app-footer></app-footer>

  </div>

</mat-drawer-container>
